/**
 * 创建人：袁俊双
 * 时间：2019-11-19
 * 描述：将流程显示区域的 0  1  2  3  转化为对应区域
 * 更新记录: 
 */
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'flowShowArea'
})
export class FlowShowAreaPipe implements PipeTransform {

 //获取当前dom节点
 constructor(){}
 
  /**
   * 管道的初始化方法
   * @param value 将流程显示区域的 0  1  2  3  转化为对应区域
   */
  transform(value: number|any ): any {
    value = value.toString()
    if(value == "0" || value){
      switch (value){
        case "0":  return '不在业务中心显示'
        case "1":  return '在业务中心显示'
        case "2":  return '在钉钉显示'
        case "3":  return '在业务中心和钉钉显示'
      }
    } 
  }

}
